import { Component, Input, OnInit } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { DATES_OPTIONS } from 'src/app/modules/dealer-dashboard/modules/menus/consts/dates-options.const';
import { Option } from '../../models/option.interface';

@Component({
  selector: 'app-menus-chart',
  templateUrl: './menus-chart.component.html',
  styleUrls: ['./menus-chart.component.scss']
})
export class MenusChartComponent implements OnInit {
  @Input() chartData!: ChartData;
  @Input() chartOptions!: ChartOptions;
  @Input() showSwitcher: boolean = false;
  @Input() title!: string;
  activeDateOption!: Option;
  protected readonly DATES_OPTIONS = DATES_OPTIONS;

  constructor() { }

  ngOnInit(): void {
    this.activeDateOption = this.DATES_OPTIONS[0];
  }

  selectDateOption(option: Option): void {
    this.activeDateOption = option;
  }
}
